var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31093 1.76409L7.15888 4.63311L7.26477 4.99139H7.63837L10.5069 4.99139L8.14673 6.87655L7.88396 7.08643L7.97928 7.40894L8.85614 10.3758L6.62298 8.5921L6.31093 8.34286L5.99889 8.5921L3.76572 10.3758L4.64259 7.40894L4.73791 7.08643L4.47514 6.87655L2.11497 4.99139L4.9835 4.99139H5.3571L5.46299 4.63311L6.31093 1.76409Z",
    stroke: "#F58120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStarIcon);
export default __webpack_public_path__ + "static/media/empty_Star_icon.9a8c2b01f439a1f4b636535d2edbc3ed.svg";
export { ForwardRef as ReactComponent };